var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 47,
    viewBox: "0 0 50 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.0871 0.327148C38.6299 0.327148 49.6586 10.6262 49.6586 23.2974C49.6586 35.942 38.6299 46.2411 25.0871 46.2411C11.5443 46.2411 0.515625 35.942 0.515625 23.2974C0.515625 10.6262 11.5443 0.327148 25.0871 0.327148ZM22.2884 14.17C21.7666 14.17 21.2686 14.2807 20.7942 14.5022C20.2013 14.8123 19.7269 15.2996 19.466 15.8754C19.3 16.2741 19.0391 17.4701 19.0391 17.4923C18.7782 18.7991 18.6359 20.9253 18.6359 23.2731C18.6359 25.5123 18.7782 27.5477 18.9917 28.8766C19.0154 28.8988 19.2763 30.3828 19.5609 30.8922C20.0827 31.8224 21.1025 32.3983 22.1935 32.3983H22.2884C22.9999 32.3761 24.4942 31.8003 24.4942 31.7781C27.0082 30.8036 31.9652 27.7692 33.9575 25.7537L34.0998 25.6208C34.3607 25.3772 34.6927 25.0007 34.7639 24.9121C35.1434 24.4469 35.3331 23.8711 35.3331 23.2974C35.3331 22.6529 35.1197 22.0549 34.7165 21.5676C34.6216 21.479 34.2658 21.1025 33.9338 20.7924C31.9889 18.8433 26.9134 15.654 24.257 14.6794C23.8538 14.5266 22.8339 14.1922 22.2884 14.17Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlay);
export default __webpack_public_path__ + "static/media/Play.63f82193282400881966dece044c7722.svg";
export { ForwardRef as ReactComponent };